import { createContext } from 'react';

export type AdvisorInfo = {
  username: string;
  firstName: string;
  lastName: string;
  phone: string;
  position: string;
} | null;

export type AdvisorContextType = {
  advisor: AdvisorInfo;
  setAdvisor: (advisor: AdvisorInfo) => void;
  clearAdvisor: () => void;
  hasAdvisor: boolean;
  advisorDisplayName: string;
};

export const AdvisorContext = createContext<AdvisorContextType | undefined>(
  undefined
);
